"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOAST_CODE_ERRORS_LIST = exports.TOAST_ERRORS_LIST = exports.CORS_CONFIGURATION_REQUIRED_TOAST = exports.SCHEDULER_SERVER_HTML_MESSAGE_TOAST = exports.FORGOT_PASSWORD_SUCCESS_TOAST = exports.SCHEDULER_TIMEZONE_NOT_SELECTED_ERROR_MESSAGE = exports.SCHEDULER_USER_DOES_NOT_HAVE_NECESSARY_PERMISSIONS_ERROR_MESSAGE = exports.SCHEDULER_TIME_SLOT_TO_SHORT_ERROR_MESSAGE = exports.NO_ACTIVE_WORKSPACES_ERROR_MESSAGE = exports.SCHEDULER_BOOKED_ERROR_MESSAGE = exports.SCHEDULER_BOOKED_SUCCESS_MESSAGE = exports.SCHEDULER_CREATE_BOOKING_PAGE_ERROR = exports.RESEND_USER_INVITE_ERROR_TOAST = exports.PRICING_TIER_ACCESS_EXCEPTION_TOAST = exports.IMPORT_LOCATIONS_LIMIT_ERROR_TOAST = exports.INVALID_GOOGLE_MAP_API_KEY_ERROR_TOAST = exports.DELETE_ROLE_ASSIGNED_ERROR_TOAST = exports.ACCOUNT_ALREADY_EXIST_ERROR_TOAST = exports.TRIAL_LIMIT_ERROR_TOAST = exports.USER_DEACTIVATED_ERROR_TOAST = exports.ROLE_DEACTIVATED_ERROR_TOAST = exports.GET_MAIN_DATA_ERROR_TOAST = exports.CHOOSE_AN_ACCOUNT_ERROR_TOAST = exports.DELETE_USER_ERROR_TOAST = exports.DELETE_USER_SUCCESS_TOAST = exports.GET_USER_LOGOUT_ERROR_TOAST = exports.GET_USER_LOGIN_ERROR_TOAST = exports.GET_USER_AUTH_ERROR_TOAST = exports.TOAST_ERROR_ID = exports.TOASTS_QUEUE_MAX_LENGTH = exports.TOAST_10_SEC_DURATION = exports.TOAST_ERROR_DURATION = exports.TOAST_SUCCESS_LONG_DURATION = exports.TOAST_SUCCESS_DURATION = exports.TOAST_INFO_COLOR = exports.TOAST_ERROR_COLOR = exports.TOAST_SUCCESS_COLOR = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const labels_1 = __importDefault(require("@/app/shared/i18n/labels"));
const statusCodes_1 = require("./statusCodes");
exports.TOAST_SUCCESS_COLOR = 'success';
exports.TOAST_ERROR_COLOR = 'error';
exports.TOAST_INFO_COLOR = 'info';
exports.TOAST_SUCCESS_DURATION = 3000;
exports.TOAST_SUCCESS_LONG_DURATION = 6000;
exports.TOAST_ERROR_DURATION = 6000;
exports.TOAST_10_SEC_DURATION = 10000;
exports.TOASTS_QUEUE_MAX_LENGTH = 3;
var TOAST_ERROR_ID;
(function (TOAST_ERROR_ID) {
    TOAST_ERROR_ID["GET_USER_AUTH_ERROR_MESSAGE"] = "GET_USER_AUTH_ERROR_MESSAGE";
    TOAST_ERROR_ID["GET_USER_LOGIN_ERROR_MESSAGE"] = "GET_USER_LOGIN_ERROR_MESSAGE";
    TOAST_ERROR_ID["GET_USER_LOGOUT_ERROR_MESSAGE"] = "GET_USER_LOGOUT_ERROR_MESSAGE";
    TOAST_ERROR_ID["DELETE_USER_SUCCESS_MESSAGE"] = "DELETE_USER_SUCCESS_MESSAGE";
    TOAST_ERROR_ID["DELETE_USER_ERROR_MESSAGE"] = "DELETE_USER_ERROR_MESSAGE";
    TOAST_ERROR_ID["CHOOSE_AN_ACCOUNT_ERROR_TOAST"] = "CHOOSE_AN_ACCOUNT_ERROR_TOAST";
    TOAST_ERROR_ID["GET_MAIN_DATA_ERROR_MESSAGE"] = "GET_MAIN_DATA_ERROR_MESSAGE";
    TOAST_ERROR_ID["ROLE_DEACTIVATED_ERROR_MESSAGE"] = "ROLE_DEACTIVATED_ERROR_MESSAGE";
    TOAST_ERROR_ID["USER_DEACTIVATED_ERROR_MESSAGE"] = "USER_DEACTIVATED_ERROR_MESSAGE";
    TOAST_ERROR_ID["TRIAL_LIMIT_ERROR_MESSAGE"] = "TRIAL_LIMIT_ERROR_MESSAGE";
    TOAST_ERROR_ID["ACCOUNT_ALREADY_EXIST_ERROR_TOAST_MESSAGE"] = "ACCOUNT_ALREADY_EXIST_ERROR_TOAST_MESSAGE";
    TOAST_ERROR_ID["DELETE_ROLE_ASSIGNED_ERROR_MESSAGE"] = "DELETE_ROLE_ASSIGNED_ERROR_MESSAGE";
    TOAST_ERROR_ID["INVALID_GOOGLE_MAP_API_KEY_ERROR_MESSAGE"] = "INVALID_GOOGLE_MAP_API_KEY_ERROR_MESSAGE";
    TOAST_ERROR_ID["IMPORT_LOCATIONS_LIMIT_ERROR_MESSAGE"] = "IMPORT_LOCATIONS_LIMIT_ERROR_MESSAGE";
    TOAST_ERROR_ID["PRICING_TIER_ACCESS_EXCEPTION_MESSAGE"] = "PRICING_TIER_ACCESS_EXCEPTION_MESSAGE";
    TOAST_ERROR_ID["RESEND_USER_INVITE_ERROR_MESSAGE"] = "RESEND_USER_INVITE_ERROR_MESSAGE";
    TOAST_ERROR_ID["SCHEDULER_CREATE_BOOKING_PAGE_ERROR"] = "SCHEDULER_CREATE_BOOKING_PAGE_ERROR";
    TOAST_ERROR_ID["SCHEDULER_BOOKED_SUCCESS_MESSAGE"] = "SCHEDULER_BOOKED_SUCCESS_MESSAGE";
    TOAST_ERROR_ID["SCHEDULER_BOOKED_ERROR_MESSAGE"] = "SCHEDULER_BOOKED_ERROR_MESSAGE";
    TOAST_ERROR_ID["NO_ACTIVE_WORKSPACES"] = "NO_ACTIVE_WORKSPACES";
    TOAST_ERROR_ID["SCHEDULER_TIME_SLOT_TO_SHORT"] = "SCHEDULER_TIME_SLOT_TO_SHORT";
    TOAST_ERROR_ID["SCHEDULER_USER_DOES_NOT_HAVE_NECESSARY_PERMISSIONS"] = "SCHEDULER_USER_DOES_NOT_HAVE_NECESSARY_PERMISSIONS";
    TOAST_ERROR_ID["SCHEDULER_TIMEZONE_NOT_SELECTED"] = "SCHEDULER_TIMEZONE_NOT_SELECTED";
    TOAST_ERROR_ID["FORGOT_PASSWORD_SUCCESS_MESSAGE"] = "FORGOT_PASSWORD_SUCCESS_MESSAGE";
    TOAST_ERROR_ID["SCHEDULER_SERVER_HTML_MESSAGE"] = "SCHEDULER_SERVER_HTML_MESSAGE";
    TOAST_ERROR_ID["CORS_CONFIGURATION_REQUIRED"] = "CORS_CONFIGURATION_REQUIRED";
})(TOAST_ERROR_ID = exports.TOAST_ERROR_ID || (exports.TOAST_ERROR_ID = {}));
exports.GET_USER_AUTH_ERROR_TOAST = {
    id: TOAST_ERROR_ID.GET_USER_AUTH_ERROR_MESSAGE,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    detail: labels_1.default.GET_USER_AUTH_ERROR_MESSAGE,
};
exports.GET_USER_LOGIN_ERROR_TOAST = {
    id: TOAST_ERROR_ID.GET_USER_LOGIN_ERROR_MESSAGE,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    detail: labels_1.default.GET_USER_LOGIN_ERROR_MESSAGE,
};
exports.GET_USER_LOGOUT_ERROR_TOAST = {
    id: TOAST_ERROR_ID.GET_USER_LOGOUT_ERROR_MESSAGE,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    detail: labels_1.default.GET_USER_LOGOUT_ERROR_MESSAGE,
};
exports.DELETE_USER_SUCCESS_TOAST = {
    id: TOAST_ERROR_ID.DELETE_USER_SUCCESS_MESSAGE,
    severity: exports.TOAST_SUCCESS_COLOR,
    life: exports.TOAST_SUCCESS_DURATION,
    detail: labels_1.default.DELETE_USER_SUCCESS_MESSAGE,
};
exports.DELETE_USER_ERROR_TOAST = {
    id: TOAST_ERROR_ID.DELETE_USER_ERROR_MESSAGE,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    detail: labels_1.default.DELETE_USER_ERROR_MESSAGE,
};
exports.CHOOSE_AN_ACCOUNT_ERROR_TOAST = {
    id: TOAST_ERROR_ID.CHOOSE_AN_ACCOUNT_ERROR_TOAST,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    detail: labels_1.default.CHOOSE_AN_ACCOUNT_ERROR_TOAST,
};
exports.GET_MAIN_DATA_ERROR_TOAST = {
    id: TOAST_ERROR_ID.GET_MAIN_DATA_ERROR_MESSAGE,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    detail: labels_1.default.GET_MAIN_DATA_ERROR_MESSAGE,
};
exports.ROLE_DEACTIVATED_ERROR_TOAST = {
    id: TOAST_ERROR_ID.ROLE_DEACTIVATED_ERROR_MESSAGE,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    detail: labels_1.default.ROLE_DEACTIVATED_ERROR_MESSAGE,
};
exports.USER_DEACTIVATED_ERROR_TOAST = {
    id: TOAST_ERROR_ID.USER_DEACTIVATED_ERROR_MESSAGE,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    detail: labels_1.default.USER_DEACTIVATED_ERROR_MESSAGE,
};
exports.TRIAL_LIMIT_ERROR_TOAST = {
    id: TOAST_ERROR_ID.TRIAL_LIMIT_ERROR_MESSAGE,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    detail: labels_1.default.TRIAL_LIMIT_ERROR_MESSAGE,
    content: () => ((0, jsx_runtime_1.jsxs)("div", { className: 'flex flex-column gap-12px flex-1', children: [(0, jsx_runtime_1.jsx)("div", { className: 'text-title-xs-med', children: labels_1.default.SCHEDULER_ERROR }), (0, jsx_runtime_1.jsxs)("div", { className: 'flex flex-column gap-6px text-label-s-reg', children: [(0, jsx_runtime_1.jsx)("div", { children: labels_1.default.SCHEDULER_CREATE_BOOKING_PAGE_LIMIT_ERROR }), (0, jsx_runtime_1.jsx)("a", { href: 'https://omnito.ai/pricing/', target: '_blank', children: labels_1.default.SCHEDULER_CREATE_BOOKING_PAGE_LIMIT_LINK })] })] })),
};
exports.ACCOUNT_ALREADY_EXIST_ERROR_TOAST = {
    id: TOAST_ERROR_ID.ACCOUNT_ALREADY_EXIST_ERROR_TOAST_MESSAGE,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    detail: labels_1.default.ACCOUNT_ALREADY_EXIST_ERROR_TOAST_MESSAGE,
};
exports.DELETE_ROLE_ASSIGNED_ERROR_TOAST = {
    id: TOAST_ERROR_ID.DELETE_ROLE_ASSIGNED_ERROR_MESSAGE,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    detail: labels_1.default.DELETE_ROLE_ASSIGNED_ERROR_MESSAGE,
};
exports.INVALID_GOOGLE_MAP_API_KEY_ERROR_TOAST = {
    id: TOAST_ERROR_ID.INVALID_GOOGLE_MAP_API_KEY_ERROR_MESSAGE,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    detail: labels_1.default.INVALID_GOOGLE_MAP_API_KEY_ERROR_MESSAGE,
};
exports.IMPORT_LOCATIONS_LIMIT_ERROR_TOAST = {
    id: TOAST_ERROR_ID.IMPORT_LOCATIONS_LIMIT_ERROR_MESSAGE,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    detail: labels_1.default.IMPORT_LOCATIONS_LIMIT_ERROR_MESSAGE,
};
exports.PRICING_TIER_ACCESS_EXCEPTION_TOAST = {
    id: TOAST_ERROR_ID.PRICING_TIER_ACCESS_EXCEPTION_MESSAGE,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    detail: labels_1.default.PRICING_TIER_ACCESS_EXCEPTION_MESSAGE,
};
exports.RESEND_USER_INVITE_ERROR_TOAST = {
    id: TOAST_ERROR_ID.RESEND_USER_INVITE_ERROR_MESSAGE,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    detail: labels_1.default.RESEND_USER_INVITE_ERROR_MESSAGE,
};
exports.SCHEDULER_CREATE_BOOKING_PAGE_ERROR = {
    id: TOAST_ERROR_ID.SCHEDULER_CREATE_BOOKING_PAGE_ERROR,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    detail: labels_1.default.SCHEDULER_CREATE_BOOKING_PAGE_ERROR,
};
exports.SCHEDULER_BOOKED_SUCCESS_MESSAGE = {
    id: TOAST_ERROR_ID.SCHEDULER_BOOKED_SUCCESS_MESSAGE,
    severity: exports.TOAST_SUCCESS_COLOR,
    life: exports.TOAST_SUCCESS_DURATION,
    summary: labels_1.default.SCHEDULER_BOOKED_SUCCESS_MESSAGE,
    detail: labels_1.default.SCHEDULER_BOOKED_SUCCESS_MESSAGE_CHECK_INBOX,
};
exports.SCHEDULER_BOOKED_ERROR_MESSAGE = {
    id: TOAST_ERROR_ID.SCHEDULER_BOOKED_ERROR_MESSAGE,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    summary: labels_1.default.SCHEDULER_BOOKED_ERROR_MESSAGE,
    detail: labels_1.default.SCHEDULER_BOOKED_ERROR_MESSAGE_PICK_TIME_SLOT,
};
exports.NO_ACTIVE_WORKSPACES_ERROR_MESSAGE = {
    id: TOAST_ERROR_ID.NO_ACTIVE_WORKSPACES,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    summary: labels_1.default.NO_ACTIVE_WORKSPACES_TITLE,
    detail: labels_1.default.NO_ACTIVE_WORKSPACES,
};
exports.SCHEDULER_TIME_SLOT_TO_SHORT_ERROR_MESSAGE = {
    id: TOAST_ERROR_ID.SCHEDULER_TIME_SLOT_TO_SHORT,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    summary: labels_1.default.SCHEDULER_TIME_SLOT_TO_SHORT_TITLE,
    detail: labels_1.default.SCHEDULER_TIME_SLOT_TO_SHORT_DESCRIPTION,
};
exports.SCHEDULER_USER_DOES_NOT_HAVE_NECESSARY_PERMISSIONS_ERROR_MESSAGE = {
    id: TOAST_ERROR_ID.SCHEDULER_USER_DOES_NOT_HAVE_NECESSARY_PERMISSIONS,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    summary: labels_1.default.SCHEDULER_USER_DOES_NOT_HAVE_NECESSARY_PERMISSIONS,
};
exports.SCHEDULER_TIMEZONE_NOT_SELECTED_ERROR_MESSAGE = {
    id: TOAST_ERROR_ID.SCHEDULER_TIMEZONE_NOT_SELECTED,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    summary: labels_1.default.SCHEDULER_TIMEZONE_NOT_SELECTED_TITLE,
    detail: labels_1.default.SCHEDULER_TIMEZONE_NOT_SELECTED_DESCRIPTION,
};
exports.FORGOT_PASSWORD_SUCCESS_TOAST = {
    id: TOAST_ERROR_ID.FORGOT_PASSWORD_SUCCESS_MESSAGE,
    severity: exports.TOAST_SUCCESS_COLOR,
    life: exports.TOAST_SUCCESS_DURATION,
    detail: labels_1.default.FORGOT_PASSWORD_SUCCESS_MESSAGE,
};
exports.SCHEDULER_SERVER_HTML_MESSAGE_TOAST = {
    id: TOAST_ERROR_ID.SCHEDULER_SERVER_HTML_MESSAGE,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
};
exports.CORS_CONFIGURATION_REQUIRED_TOAST = {
    id: TOAST_ERROR_ID.CORS_CONFIGURATION_REQUIRED,
    severity: exports.TOAST_ERROR_COLOR,
    life: exports.TOAST_ERROR_DURATION,
    summary: labels_1.default.CORS_CONFIGURATION_REQUIRED_TITLE,
    detail: labels_1.default.CORS_CONFIGURATION_REQUIRED_TEXT,
};
exports.TOAST_ERRORS_LIST = Object.freeze({
    [TOAST_ERROR_ID.GET_USER_AUTH_ERROR_MESSAGE]: exports.GET_USER_AUTH_ERROR_TOAST,
    [TOAST_ERROR_ID.GET_USER_LOGIN_ERROR_MESSAGE]: exports.GET_USER_LOGIN_ERROR_TOAST,
    [TOAST_ERROR_ID.GET_USER_LOGOUT_ERROR_MESSAGE]: exports.GET_USER_LOGOUT_ERROR_TOAST,
    [TOAST_ERROR_ID.DELETE_USER_SUCCESS_MESSAGE]: exports.DELETE_USER_SUCCESS_TOAST,
    [TOAST_ERROR_ID.DELETE_USER_ERROR_MESSAGE]: exports.DELETE_USER_ERROR_TOAST,
    [TOAST_ERROR_ID.CHOOSE_AN_ACCOUNT_ERROR_TOAST]: exports.CHOOSE_AN_ACCOUNT_ERROR_TOAST,
    [TOAST_ERROR_ID.GET_MAIN_DATA_ERROR_MESSAGE]: exports.GET_MAIN_DATA_ERROR_TOAST,
    [TOAST_ERROR_ID.ROLE_DEACTIVATED_ERROR_MESSAGE]: exports.ROLE_DEACTIVATED_ERROR_TOAST,
    [TOAST_ERROR_ID.USER_DEACTIVATED_ERROR_MESSAGE]: exports.USER_DEACTIVATED_ERROR_TOAST,
    [TOAST_ERROR_ID.TRIAL_LIMIT_ERROR_MESSAGE]: exports.TRIAL_LIMIT_ERROR_TOAST,
    [TOAST_ERROR_ID.ACCOUNT_ALREADY_EXIST_ERROR_TOAST_MESSAGE]: exports.ACCOUNT_ALREADY_EXIST_ERROR_TOAST,
    [TOAST_ERROR_ID.DELETE_ROLE_ASSIGNED_ERROR_MESSAGE]: exports.DELETE_ROLE_ASSIGNED_ERROR_TOAST,
    [TOAST_ERROR_ID.INVALID_GOOGLE_MAP_API_KEY_ERROR_MESSAGE]: exports.INVALID_GOOGLE_MAP_API_KEY_ERROR_TOAST,
    [TOAST_ERROR_ID.IMPORT_LOCATIONS_LIMIT_ERROR_MESSAGE]: exports.IMPORT_LOCATIONS_LIMIT_ERROR_TOAST,
    [TOAST_ERROR_ID.PRICING_TIER_ACCESS_EXCEPTION_MESSAGE]: exports.PRICING_TIER_ACCESS_EXCEPTION_TOAST,
    [TOAST_ERROR_ID.RESEND_USER_INVITE_ERROR_MESSAGE]: exports.RESEND_USER_INVITE_ERROR_TOAST,
    [TOAST_ERROR_ID.SCHEDULER_CREATE_BOOKING_PAGE_ERROR]: exports.SCHEDULER_CREATE_BOOKING_PAGE_ERROR,
    [TOAST_ERROR_ID.SCHEDULER_BOOKED_SUCCESS_MESSAGE]: exports.SCHEDULER_BOOKED_SUCCESS_MESSAGE,
    [TOAST_ERROR_ID.SCHEDULER_BOOKED_ERROR_MESSAGE]: exports.SCHEDULER_BOOKED_ERROR_MESSAGE,
    [TOAST_ERROR_ID.NO_ACTIVE_WORKSPACES]: exports.NO_ACTIVE_WORKSPACES_ERROR_MESSAGE,
    [TOAST_ERROR_ID.SCHEDULER_TIME_SLOT_TO_SHORT]: exports.SCHEDULER_TIME_SLOT_TO_SHORT_ERROR_MESSAGE,
    [TOAST_ERROR_ID.SCHEDULER_USER_DOES_NOT_HAVE_NECESSARY_PERMISSIONS]: exports.SCHEDULER_USER_DOES_NOT_HAVE_NECESSARY_PERMISSIONS_ERROR_MESSAGE,
    [TOAST_ERROR_ID.SCHEDULER_TIMEZONE_NOT_SELECTED]: exports.SCHEDULER_TIMEZONE_NOT_SELECTED_ERROR_MESSAGE,
    [TOAST_ERROR_ID.FORGOT_PASSWORD_SUCCESS_MESSAGE]: exports.FORGOT_PASSWORD_SUCCESS_TOAST,
    [TOAST_ERROR_ID.SCHEDULER_SERVER_HTML_MESSAGE]: exports.SCHEDULER_SERVER_HTML_MESSAGE_TOAST,
    [TOAST_ERROR_ID.CORS_CONFIGURATION_REQUIRED]: exports.CORS_CONFIGURATION_REQUIRED_TOAST,
});
exports.TOAST_CODE_ERRORS_LIST = Object.freeze({
    [statusCodes_1.SERVER_ERROR_CODES.FORBIDDEN]: undefined,
    [statusCodes_1.SERVER_ERROR_CODES.NOT_FOUND]: undefined,
    [statusCodes_1.SERVER_ERROR_CODES.NO_PERMISSIONS]: TOAST_ERROR_ID.SCHEDULER_USER_DOES_NOT_HAVE_NECESSARY_PERMISSIONS,
    [statusCodes_1.SERVER_ERROR_CODES.LICENSE_EXPIRED]: undefined,
    [statusCodes_1.SERVER_ERROR_CODES.UNPROCESSABLE_ENTITY]: TOAST_ERROR_ID.INVALID_GOOGLE_MAP_API_KEY_ERROR_MESSAGE,
    [statusCodes_1.SERVER_ERROR_CODES.HOST_DEACTIVATED]: undefined,
    [statusCodes_1.SERVER_ERROR_CODES.ROLE_DEACTIVATED]: TOAST_ERROR_ID.ROLE_DEACTIVATED_ERROR_MESSAGE,
    [statusCodes_1.SERVER_ERROR_CODES.USER_DEACTIVATED]: TOAST_ERROR_ID.USER_DEACTIVATED_ERROR_MESSAGE,
    [statusCodes_1.SERVER_ERROR_CODES.LICENSE_BASIC_LIMITS]: TOAST_ERROR_ID.TRIAL_LIMIT_ERROR_MESSAGE,
    [statusCodes_1.SERVER_ERROR_CODES.ROLE_CAN_T_BE_DELETED]: TOAST_ERROR_ID.DELETE_ROLE_ASSIGNED_ERROR_MESSAGE,
    [statusCodes_1.SERVER_ERROR_CODES.FAILED_TO_SWITCH_ACCOUNT]: TOAST_ERROR_ID.ACCOUNT_ALREADY_EXIST_ERROR_TOAST_MESSAGE,
    [statusCodes_1.SERVER_ERROR_CODES.ALL_SUBSCRIPTION_PLANS_RESTRICTIONS]: TOAST_ERROR_ID.PRICING_TIER_ACCESS_EXCEPTION_MESSAGE,
    [statusCodes_1.SERVER_ERROR_CODES.MEETING_TYPE_HAS_EXPIRED]: undefined,
    [statusCodes_1.SERVER_ERROR_CODES.INTERNAL_SERVER_ERROR]: undefined,
    [statusCodes_1.SERVER_ERROR_CODES.NO_AVAILABLE_USERS_ON_THE_SELECTED_TIME]: undefined,
    [statusCodes_1.SERVER_ERROR_CODES.USER_NOT_FOUND_WHEN_TRYING_TO_LOGIN]: TOAST_ERROR_ID.GET_USER_LOGIN_ERROR_MESSAGE,
    [statusCodes_1.SERVER_ERROR_CODES.ITEM_LIMITS]: TOAST_ERROR_ID.IMPORT_LOCATIONS_LIMIT_ERROR_MESSAGE,
    [statusCodes_1.SERVER_ERROR_CODES.WORKSPACE_DEACTIVATED]: undefined,
    [statusCodes_1.SERVER_ERROR_CODES.ADMIN_DATA_RECORD_WITH_THIS_EMAIL_ALREADY_CREATED_FOR_THIS_ORG]: TOAST_ERROR_ID.RESEND_USER_INVITE_ERROR_MESSAGE,
    [statusCodes_1.CLIENT_ERROR_CODES.NO_ACTIVE_WORKSPACES]: TOAST_ERROR_ID.NO_ACTIVE_WORKSPACES,
    [statusCodes_1.CLIENT_ERROR_CODES.SCHEDULER_TIME_SLOT_TO_SHORT]: TOAST_ERROR_ID.SCHEDULER_TIME_SLOT_TO_SHORT,
});
